import { CURRENT_ENV } from '../constants';

/**
 * Execute a function only if the current environment is NOT production
 * @param {function} fn
 */
export const prodOnlyExecutor = (fn = () => {}) => {
  if (CURRENT_ENV === 'STAGING' || CURRENT_ENV === 'PRODUCTION') {
    fn();
  }
};
